var _g, _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAudioNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_25580",
    "data-name": "Group 25580",
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    cx: 28,
    cy: 28,
    r: 28,
    transform: "translate(0.5 0.5)",
    fill: "#fff",
    stroke: "#e0e0e0",
    strokeWidth: 1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13609",
    d: "M31.3,17.005V16.7a1.37,1.37,0,0,1,1.848-1.3,13.728,13.728,0,0,1,0,25.658,1.376,1.376,0,0,1-1.848-1.3v-.305a1.4,1.4,0,0,1,.916-1.3,10.693,10.693,0,0,0,0-19.855A1.42,1.42,0,0,1,31.3,17.005ZM14.5,25.176v6.109a1.532,1.532,0,0,0,1.527,1.527h4.582l5.025,5.025a1.532,1.532,0,0,0,2.612-1.084V19.693a1.532,1.532,0,0,0-2.612-1.084l-5.025,5.04H16.027A1.532,1.532,0,0,0,14.5,25.176Zm20.618,3.055A6.873,6.873,0,0,0,31.3,22.076V34.37A6.833,6.833,0,0,0,35.118,28.231Z",
    transform: "translate(0.255 0.269)",
    fill: "#37c5f7",
    fillRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    cx: 28,
    cy: 28,
    r: 28,
    transform: "translate(0.5 0.5)",
    fill: "none",
    stroke: "#0074bd",
    strokeWidth: 1,
    strokeDasharray: 296,
    strokeDashoffset: 296
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioNormal);
export default __webpack_public_path__ + "static/media/audio-normal.846f90e1bb4b61830099c91f9c5e0524.svg";
export { ForwardRef as ReactComponent };